import Ajv from "ajv";
import addFormats from 'ajv-formats'
import ajvErrors from 'ajv-errors';
import dayjs from 'dayjs';
import { collectionCreateSchema } from '@collecting/client';
import {CollectionModel} from 'model/collection/CollectionModels';
import { log } from "utils/Common";

const ajv = new Ajv({ allErrors: true, $data: true, strict: false });
addFormats(ajv);
ajvErrors(ajv);

export const nextMonth = () => dayjs().add(1, 'month');
export const nextYear = () => dayjs().add(1, 'year');

const collectionValidate = ajv.compile(collectionCreateSchema);

/* VALIDATION */
export const validate = (data: CollectionModel, visited: any): Map<string, string> => {
  // dates need to be converted to strings, or have object validation
  // also collectionValidate needs to be called
  let valid = collectionValidate(data); // eslint-disable-line
  let errors = collectionValidate.errors;
  // Reset the violations
  if (!errors) {
    return new Map();
  }

  const map = new Map(errors
    .filter((e) => visited.has(e.instancePath))
    .map(toViolation));

  return map;
}

export const validateV2 = (data: CollectionModel, part: Set<string>): Map<string, string> => {
  // dates need to be converted to strings, or have object validation
  // also collectionValidate needs to be called
  let valid = collectionValidate(data); // eslint-disable-line
  let errors = collectionValidate.errors;
  log("--all collection errors--")
  log(errors)
  // Reset the violations
  if (!errors) {
    return new Map();
  }

  const map = new Map(errors
    .filter((e) => part.has(e.instancePath))
    .map(toViolation));

  log("--filtered down errors--")
  log(map)
  return map;
}

const toViolation = (error: any): [string, string] => {
  log("--individual error--")
  log(error)
  return [error.instancePath, error.message]
}

export const validateEndDate = (isNew: boolean, 
  endDate: dayjs.Dayjs, status: string, createDateTime: string, currentEndDate: string): [string, string]| null => {

    if (!endDate.isValid()) {
      return ["endDate", `The end date is not valid`]
    }
  
  if (isNew) {
    const minDate = nextMonth();
    const maxDate = dayjs(createDateTime).add(1, 'year');
    if (endDate.isBefore(maxDate.add(1, 'day')) && 
        endDate.isAfter(minDate.add(-1, 'day'))) {
      return null;
    }
    return ["endDate", `The end date must be between ${minDate.format("MMM Do, YYYY")} and ${maxDate.format("MMM Do, YYYY")}`]
  }

  if (status === "active" || status === "paused") {
    const yearAfter = dayjs(createDateTime).add(1, 'year').add(-1, 'day')
    if (yearAfter && 
        endDate.isAfter(nextMonth().add(-1, 'day'))) {
      return null;
    }
    return ["endDate", `The end date must be between ${nextMonth().format("MMM Do, YYYY")} and ${yearAfter.format("MMM Do, YYYY")}`]
  }

  if (status === "expired") {
    const yearAfter = dayjs(currentEndDate).add(1, 'year').add(+1, 'day')
    if (endDate.isBefore(yearAfter) && 
        endDate.isAfter(nextMonth().add(-1, 'day'))) {
      return null;
    }
    return ["endDate", `The end date must be between ${nextMonth().format("MMM Do, YYYY")} and ${yearAfter.format("MMM Do, YYYY")}`]
  }

  return null;
}

/*
Array [ {…}, {…} ]
​
0: Object { instancePath: "/endDate", schemaPath: "#/properties/endDate/formatMinimum", keyword: "formatMinimum", … }
​​
instancePath: "/endDate"
​​
keyword: "formatMinimum"
​​
message: "should be >= {{min_end_date}}"
​​
params: Object { comparison: ">=", limit: "{{min_end_date}}" }
​​
schemaPath: "#/properties/endDate/formatMinimum"
​
{
  instancePath: "/paymentMethods/0"​​
  keyword: "required"​​
  message: "must have required property 'serviceUser'"​​
  params: Object { missingProperty: "serviceUser" }​​​
  missingProperty: "serviceUser"​​
  schemaPath: "#/properties/paymentMethods/items/required"
}
*/


/* 
const [templateIndex, setTemplateIndex] = useState(0);


VALIDATION
const validate = (data: any) => {
  // dates need to be converted to strings, or have object validation
  // also collectionValidate needs to be called
  let valid = collectionValidate(formData);
  let errors = collectionValidate.errors;
  // Reset the violations
  if (!errors) {
    useCollections.setState(() => ({
      violations: new Map()
    }));

    return;
  }

  const prop = "/" + data.target.name;
  let v = visited.add(prop);
  setVisited(v);

  const map = new Map(errors
    .filter((e) => v.has(e.instancePath))
    .map(toViolation));

  useCollections.setState(() => ({
    violations: new Map(map)
  }));
}

const toViolation = (error: any): [any, any] => {
  return [error.instancePath.replace("/", ""), error.message]
} */